import { MatDialog } from "@angular/material/dialog";
import { DocumentMediaModel } from "@phdsoft/common";
import { DocumentsSearchService } from "src/app/template/documents/documents-search/documents-search.service";
import { Modes } from "../Framework/mode";
import { ResourceElement } from "./ResourceElement";
import { ModalConfirmComponent } from '@phdsoft/modal-confirm';
import { DocumentsListService } from "src/app/template/documents/documents-list/documents-list.service";

export class DocumentResource extends ResourceElement {
    public dialog: MatDialog;
    private documentsListService: DocumentsListService;
    private documentsSearchService: DocumentsSearchService;

    private _documentMediaModel: DocumentMediaModel;
    public get documentMediaModel(): DocumentMediaModel {
        return this._documentMediaModel;
    }
    public set documentMediaModel(v: DocumentMediaModel) {
        this._documentMediaModel = v;
    }


    private _documentMode: Modes;
    public get documentMode(): Modes {
        return this._documentMode;
    }
    public set documentMode(v: Modes) {
        this._documentMode = v;
    }

    private _regionIds: Array<string>;
    public get regionIds(): Array<string> {
        return this._regionIds;
    }
    public set regionIds(v: Array<string>) {
        this._regionIds = v;
    }

    constructor(document: DocumentMediaModel, mode: Modes, documentsSearchService: DocumentsSearchService,
        documentsListService: DocumentsListService, dialog: MatDialog) {
        super();
        this.Guid = document.Id;
        this.HolderId = document.ElementId;
        this._documentMediaModel = document;
        this._documentMode = mode;
        this.documentsSearchService = documentsSearchService;
        this.documentsListService = documentsListService;
        this.dialog = dialog;
    }

    public get elementId(): string {
        return this.documentMediaModel.ElementId;
    }

    public get sectionId(): string {
        return this.documentMediaModel.SectionId;
    }

    public get regionId(): string {
        return this.documentMediaModel.RegionId;
    }

    public get assetId(): string {
        return this.documentMediaModel.AssetId;
    }


    public openDocument(): void {
        this.documentsSearchService.download(this.documentMediaModel);
    }

    public deleteDocument(): void {
        const dialogRef = this.dialog.open(ModalConfirmComponent, {
            data: {
                title: 'Confirm delete',
                question: `Delete this item?`,
            },
            hasBackdrop: true,
            panelClass: 'transparentModal',
        });
        dialogRef.afterClosed().subscribe(async (data) => {
            if (data?.result) {
                const returnedValue = await this.documentsListService.deleteImage(this._documentMediaModel.Id ?
                    this._documentMediaModel.Id : this._documentMediaModel.id) as any;
                if (returnedValue === 'true') {
                    // if (this._sprite) {
                    //     const parent = this._sprite.parent;
                    //     parent.remove(this._sprite);
                    // }
                    this.dialog.closeAll();
                }
            }
        });
    }
}
